module.exports = __webpack_public_path__ + "static/media/emirates.8e160e9d.png";